/**
 * API Configuration
 * Dynamically determines the correct backend URL based on the current environment
 * 
 * IMPORTANT: Always call getBackendUrl() or getApiUrl() at RUNTIME, not at module load time.
 * The URL is determined by window.location which is only correct at runtime.
 */

// Get the backend URL - always use the current origin for API calls
// This ensures the app works on any domain (preview, production, etc.)
export const getBackendUrl = () => {
  // Always use the current origin - this works for both preview and production
  // The Kubernetes ingress routes /api/* to the backend automatically
  return window.location.origin;
};

// API base URL with /api prefix
export const getApiUrl = () => `${getBackendUrl()}/api`;

// DEPRECATED: These constants are evaluated at module load time and may not work correctly
// Use getBackendUrl() and getApiUrl() instead
export const API_URL = ''; // Deprecated - use getBackendUrl()
export const API = ''; // Deprecated - use getApiUrl()

export default {
  getBackendUrl,
  getApiUrl,
  API_URL,
  API
};
